
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import EventStatisticsPanel from '@/components/admin/EventStatisticsPanel';
import RealTimeMetrics from '@/components/admin/analytics/RealTimeMetrics';

const AdminDashboard = () => {
  return (
    <div className="flex-1 space-y-4 p-4 md:p-8 pt-6">
      <div className="flex items-center justify-between">
        <h2 className="text-3xl font-bold tracking-tight">Admin Dashboard</h2>
      </div>
      
      <Tabs defaultValue="realtime" className="space-y-4">
        <TabsList>
          <TabsTrigger value="realtime">Valós idő Analytics</TabsTrigger>
          <TabsTrigger value="events">Esemény Statisztikák</TabsTrigger>
        </TabsList>
        
        <TabsContent value="realtime" className="space-y-4">
          <RealTimeMetrics />
        </TabsContent>
        
        <TabsContent value="events" className="space-y-4">
          <EventStatisticsPanel />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AdminDashboard;
